export const FIVE_MINUTES = 5 * 60 * 1000
export const ONE_MINUTE = 1 * 60 * 1000
